import SVG from 'react-inlinesvg';
import { clsx } from 'clsx';

interface MainLayoutProps {
  children: React.ReactNode;
  className?: string;
  logoColor?: string;
}

export const MainLayout = ({ children, className }: MainLayoutProps) => {
  return (
    <main
      className={clsx(
        'flex flex-col w-full h-full overflow-y-auto min-h-full',
        className,
      )}
    >
      <div className="flex flex-col w-full flex-1 ">{children}</div>
      <div className="flex justify-center items-center my-5">
        <SVG
          className="h-[12px]"
          src="../../assets/pay-with-autopass.svg"
          color="#999999"
        />
      </div>
    </main>
  );
};
